
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLogic03Off as ObiLogic03OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-logic-03-off.js';
 
 
 

 
 export const ObiLogic03Off = createComponent({
   react: React,
   tagName: 'obi-logic-03-off',
   elementClass: ObiLogic03OffElement,
   events: {
     
   }
  });
 
 